import { Inject, Injectable, NgZone } from '@angular/core';
import { Ng1NgxUrlHandlingStrategyService } from '../../routing/services/ng1-ngx-url-handling-strategy.service';
import * as angular from 'angular';
import { FNW_NAVIGATION_ROUTE, FnwLocationUpdate, FnwReceiveMessage, Section } from '@farmnet/webapp-loader-companion';
import { filter, map } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class AngularJsLocationSyncService {

    private static stripTrailingSlash(text: string) {
        if (text.endsWith('/')) {
            return text.substring(0, text.length - 1);
        }
        return text;
    }

    managedByAngularLocationSync = false;
    locationChangeSent = false; // Avoid sending 2 fnx-location-update
    currentSection: Section;

    constructor(
        private urlHandlingStrategy: Ng1NgxUrlHandlingStrategyService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService,
        @Inject('$route') private $route: angular.route.IRouteService,
        @Inject('$location') private $location: angular.ILocationService,
        @Inject('navigationService') private navigationService: any,
        private ngZone: NgZone
    ) {
    }

    public startLocationSync() {
        this.$rootScope.$on('$routeChangeStart', (/* event, currentRoute: angular.route.ICurrentRoute */) => {
            // Start navigation
            this.locationChangeSent = false;
            // Navigation cicle for AngularJS is started we ensure to reset cancel state on navigationService
            this.navigationService.resetNavigationCancelled();
            // Navigation should be managed by AngularJS
            this.managedByAngularLocationSync = false;
        });
        this.$rootScope.$on('$locationChangeSuccess', (event/* , currentRoute: string */) => {
            this.notifyWebappLoaderIfNecessary(event, this.currentSection);
        });
        this.$rootScope.$on('$routeChangeSuccess', (event, currentRoute: angular.route.ICurrentRoute) => {
            // Navigation managed by AngularJS
            this.currentSection = currentRoute.locals.section || (event.targetScope as any).sectionName;
            this.notifyWebappLoaderIfNecessary(event, this.currentSection);
        });

        fromEvent(window, 'message').pipe(
            filter((event: MessageEvent) => event.origin === location.origin),
            map((event: MessageEvent) => event.data),
            filter(
                (data: FnwReceiveMessage) => data.type && data.type.startsWith('fnw-')
            )
        ).subscribe((data) => {
            switch (data.type) {
                case 'fnw-test-navigate-in-service': {
                    if(!this.urlHandlingStrategy.isAngularRoute()) {
                        if (location.hash !== '#' + data.url) {
                            location.hash = '#' + data.url;
                        }
                    }
                    break;
                }
                case 'fnw-test-navigate-to-service': {
                    if(!this.urlHandlingStrategy.isAngularRoute()) {
                        this.ngZone.run(() => {
                            // todo check hash location.hash = '/' + FNW_NAVIGATION_ROUTE;
                            this.$location.url('/' + FNW_NAVIGATION_ROUTE);
                        })
                    }
                    break;
                }
            }
        });
    }

    public notifyWebappLoaderIfNecessary(event: angular.IAngularEvent, section: Section) {
        // Use path only for checking route
        const urlPath = AngularJsLocationSyncService.stripTrailingSlash(this.$location.path());
        const isAngularRoute = this.urlHandlingStrategy.shouldProcessUrl(urlPath);
        const managedByAngularLocationSync = this.managedByAngularLocationSync;

        if (!isAngularRoute && !managedByAngularLocationSync) {
            const strippedLocationUrl = this.getStrippedLocationUrl(); // URL with query
            this.notifyWebappLoader(strippedLocationUrl, section);
        }
    }

    private getStrippedLocationUrl(): string {
        let resultUrl = AngularJsLocationSyncService.stripTrailingSlash(this.$location.path());
        const fullUrl = this.$location.url();
        const queryIndex = fullUrl.indexOf('?');
        if (queryIndex !== -1) {
            resultUrl += '?' + fullUrl.substr(queryIndex + 1);
        }
        return resultUrl;
    }

    public notifyWebappLoader(url: string = this.getStrippedLocationUrl(), section: Section = 'dashboard') {
        const message: FnwLocationUpdate = {
            type: 'fnw-location-update',
            serviceName: '',
            url,
            section
        };

        parent.postMessage(message, location.origin);
    }
}
